import { render, staticRenderFns } from "./validation-errors.vue?vue&type=template&id=1860a345&scoped=true&"
import script from "./validation-errors.vue?vue&type=script&lang=js&"
export * from "./validation-errors.vue?vue&type=script&lang=js&"
import style0 from "./validation-errors.vue?vue&type=style&index=0&id=1860a345&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1860a345",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1860a345')) {
      api.createRecord('1860a345', component.options)
    } else {
      api.reload('1860a345', component.options)
    }
    module.hot.accept("./validation-errors.vue?vue&type=template&id=1860a345&scoped=true&", function () {
      api.rerender('1860a345', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/validation-errors.vue"
export default component.exports